import ApplicationController from '../../javascript/controllers/application_controller'

// Marketing::MarkdownActions — copies a page's Markdown rendition to the clipboard.
// Where the clipboard cannot be written, the .md URL opens in a new tab instead.
export default class extends ApplicationController {
  static targets = ['label']
  static values = {
    url: String,
    copiedLabel: String,
    resetTime: { type: Number, default: 3 }, // in seconds
  }

  connect() {
    this.resetTimer = null
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }

  async copy() {
    try {
      await this.#writeMarkdown()
      this.#showCopied()
    } catch (error) {
      this.reportError(error, { action: 'copy' })
      window.open(this.urlValue, '_blank', 'noopener')
    }
  }

  // private

  // Hands the pending fetch to the clipboard so Safari keeps the user gesture.
  async #writeMarkdown() {
    if (window.ClipboardItem && navigator.clipboard?.write) {
      const blob = this.#fetchMarkdown().then((text) => new Blob([text], { type: 'text/plain' }))
      await navigator.clipboard.write([new ClipboardItem({ 'text/plain': blob })])
    } else {
      await navigator.clipboard.writeText(await this.#fetchMarkdown())
    }
  }

  async #fetchMarkdown() {
    const response = await fetch(this.urlValue, { headers: { Accept: 'text/markdown' } })
    if (!response.ok) throw new Error(`Markdown fetch failed: ${response.status}`)

    return response.text()
  }

  #showCopied() {
    if (!this.hasLabelTarget) return

    this.originalLabel ??= this.labelTarget.textContent
    this.labelTarget.textContent = this.copiedLabelValue
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      this.labelTarget.textContent = this.originalLabel
    }, this.resetTimeValue * 1000)
  }
}
